import http from 'plugins/axios';

export default {
//获取所有交易对
getAllSymbol({buyCoin,page,size,symbol,state}){
  return http.get({
    url:`/la/admin/symbol/findAll?buyCoin=${buyCoin}&page=${page}&size=${size}&symbol=${symbol}&state=${state}`
  })
},
  //总成交额统计
  getTurnover(data) {
    return http.post({
      url: `/la/admin/statistics/total-trade`,
    data
    });
  },
  //交易人数-交易次数
  getTranscation(data){
    return http.post({
      url:`/la/admin/statistics/total-user-number`,
      data
    })
  },
  //用户盈利排行榜
  getUserProfit({startTime,endTime,type}){
    return http.get({
      url:`/la/admin/statistics/trade-userRanking?startTime=${startTime}&endTime=${endTime}&type=${type}`
    })
  },
  //交易对盈利榜
  getSymbolProfit({startTime,endTime,type}){
    return http.get({
      url:`/la/admin/statistics/trade-symbolRanking?startTime=${startTime}&endTime=${endTime}&type=${type}`
    })
  },
  //柱状图统计
  getColumnData(tradeCountQo){
    return http.post({
      url:`/la/admin/statistics/trade-column`,
      data:{...tradeCountQo}
    })
  },
  //;导出报表
  exportExcel(tradeCountQo){
    return http.post({
      url:`/la/admin/statistics/export-excel`,
      responseType:'blob',
      data:{...tradeCountQo}
    })
  },
  //图表统计
  getStaticalChart(tradeCountQo){
    return http.post({
      url:`/la/admin/statistics/trade-chart?page=${tradeCountQo.page}&size=${tradeCountQo.size}`,
      data:{...tradeCountQo}
    })
  },
  //图表统计合计
  getTotalStatical(tradeCountQo){
    return http.post({
      url:`/la/admin/statistics/trade-chart-count`,
      data:{...tradeCountQo}
    })
  }
 
};
